module.exports = __webpack_public_path__ + "img/user.d5852f44.svg";